import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';

type PdfResult = { fileName: string; base64: string };

@Injectable({ providedIn: 'root' })
export class PdfService {
  constructor(private http: HttpClient) { }

  async GeneratePDF(
    htmlPath: string,
    fileName: string,
    replacements: Record<string, string>
  ): Promise<PdfResult> {

    const html2pdf = (await import('html2pdf.js')).default;

    const htmlTemplate = await this.loadTemplate(htmlPath);
    const html = this.applyReplacements(htmlTemplate, replacements);

    const finalName = fileName.endsWith('.pdf') ? fileName : `${fileName}.pdf`;

      // ✅ give browser a tick to layout styles/fonts
      await new Promise(r => requestAnimationFrame(() => r(null)));
      await new Promise(r => setTimeout(r, 50));

      const worker = html2pdf()
        .from(html)
        .set({
          margin: 10,
          filename: finalName,
          html2canvas: {
            scale: 2,
            useCORS: true,
            backgroundColor: '#ffffff',
            scrollX: 0,
            scrollY: 0
          },
          jsPDF: {
            unit: 'pt',
            format: 'letter',
            orientation: 'portrait'
          },
          pagebreak: { mode: ['css', 'legacy'] }
        });

      const blob: Blob = await (worker as any).toPdf().outputPdf('blob');
      console.log('blob size:', blob.size);



      const base64 = await this.blobToBase64(blob);
      return { fileName: finalName, base64 };
  }

  private blobToBase64(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const r = new FileReader();
      r.onerror = reject;
      r.onload = () => {
        const s = String(r.result || '');
        const b64 = s.includes(',') ? s.split(',')[1] : s;
        resolve(b64);
      };
      r.readAsDataURL(blob);
    });
  }

  private async loadTemplate(path: string): Promise<string> {
    return await lastValueFrom(this.http.get(path, { responseType: 'text' }));
  }

  private applyReplacements(template: string, reps: Record<string, string>): string {
    let html = template;
    for (const k of Object.keys(reps)) {
      html = html.split(k).join(reps[k] ?? '');
    }
    return html;
  }

  private extractBody(html: string): string {
    const match = html.match(/<body[^>]*>([\s\S]*?)<\/body>/i);
    return match ? match[1] : html;
  }

}
